<template>
  <div class="split-apply" v-if="!loading">
    <template v-if="!showInfo">
      <!-- 签约提醒 -->
      <div class="apply-tip" v-if="!isForm">
        <i class="el-icon-warning-outline"></i>
        <p class="tip-title">请确保已完成线下签约后再提交资料</p>
        <p class="tip-subt">进行分账结算前，需要贵公司与我司完成线下签约。</p>
        <el-button type="primary" size="medium" @click="isForm = true">提交资料</el-button>
      </div>
      <!-- 填写申请 -->
      <div class="apply-form" v-else>
        <split-apply-form @save="submit" @cancel="cancel" :info="applyInfo" />
      </div>
    </template>
    <!-- 审批账户信息 -->
    <split-apply-info v-else :info="applyInfo" @reloadInfo="getApplyByCompId" @resubmit="resubmit" @save="submit" />
  </div>
</template>
<script>
import { Message } from "element-ui";
import { SplitService } from "../../apis/split";
import { CacheService } from "../../service/common";
import splitApplyForm from "./split-apply-form.vue";
import splitApplyInfo from "./split-apply-info.vue";

export default {
  components: { splitApplyInfo, splitApplyForm },
  data() {
    return {
      applyInfo: null,
      isForm: false,
      loading: true,
      showInfo: false,
    }
  },
  mounted() {
    this.getApplyByCompId();
  },
  methods: {
    getApplyByCompId() {
      const { compId } = CacheService.get("comp");
      SplitService.getSplitApplyByCompId(compId).then(info => {
        this.loading = false;
        this.applyInfo = info;
        this.showInfo = !!info;
      })
    },
    async submit(formData) {
      if (formData.id) {
        await SplitService.modifySplitApply(formData);
      } else {
        await SplitService.addSplitApply(formData);
      }
      this.getApplyByCompId();
      Message.success("提交成功");
    },
    resubmit() {
      this.showInfo = false;
      this.isForm = true;
    },
    cancel() {
      this.isForm = false;
      this.showInfo = !!this.applyInfo;
    }
  }
};
</script>
<style lang="scss">
.split-apply {
  position: relative;
  padding: 0 !important;
}
.apply-tip {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  text-align: center;
  .el-icon-warning-outline {
    font-size: 60px;
    color: #ffb74b;
    font-weight: bolder;
  }
  .tip-title {
    margin-top: 40px;
    font-size: 18px;
    line-height: 2;
    font-weight: bold;
  }
  .tip-subt {
    margin-bottom: 100px;
    color: #909399;
  }
}
.apply-form {
  width: 700px;
  margin: 30px auto;
}
</style>